import xgimiMonitor from 'xgimi-monitor';
import { matchPath } from 'react-router-dom';
import { Path, getBasename } from '@/router/config';
import Env from '@/constants/Env';

let environment: string | null;
switch (process.env.REACT_APP_ENV) {
  case Env.Dev:
    environment = 'daily';
    break;
  case Env.Pre:
    environment = 'pre';
    break;
  case Env.Production:
    environment = 'prod';
    break;
  default:
    environment = 'prod';
    break;
}
xgimiMonitor.init({
  pid: process.env.REACT_APP_MONITOR_PID!,
  environment,
});
// const monitor = xgimiMonitor.init({
//   pid: process.env.REACT_APP_MONITOR_PID!,
//   environment,
//   // 对上报的路径进行去参聚合
//   parseHash: () => {
//     const pathname = window.location.pathname;
//     let basename = getBasename();
//     if (basename === '/' || pathname.slice(0, basename.length) !== basename) basename = '';
//     const pathNames = Array.from(Path.keys());
//     for (let i = 0; i < pathNames.length; i++) {
//       const key = pathNames[i];
//       const path = `${basename}${Path.get(key)}`;
//       if (matchPath(pathname, { path, exact: true })) {
//         return path;
//       }
//     }
//     return pathname;
//   },
// });

// export default monitor;
